module.exports = __webpack_public_path__ + "img/image5.edd37b71.png";